import axios from 'axios';
import React, {useEffect, useState } from "react";
import vietnamData from '../locationDb.json';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const OrderFormModal = ({ isOpen, closeModal, size, gender, type, checkPoint}) => {
  const [formData, setFormData] = useState({
    giftName: "Combo áo mũ",
    gender: gender,
    giftSize: size,
    username: "",
    accountNumber: "",
    fullName: "",
    phoneNumber: "",
    province: "",
    district: "",
    commune: "",
    address: "",
    note: ""
  });
  useEffect(() => {
    if (isOpen) {
      // Khi modal mở, thiết lập lại userData với dữ liệu người dùng hiện tại
      setFormData(() => ({
        giftName: "Combo áo mũ",
        gender: gender,
        giftSize: size,
        username: "",
        accountNumber: "",
        fullName: "",
        phoneNumber: "",
        province: "",
        district: "",
        commune: "",
        address: "",
        note: ""
      }));
      setErrorMessage('');
    } else {
        setIsAccountValid(false);
        setFilteredDistricts([]);
        setFilteredCommunes([]);
        setEmtyField({});
    }
  }, [isOpen]);
  const [isAccountValid, setIsAccountValid] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [emtyField, setEmtyField] = useState({});
  const [filteredDistricts, setFilteredDistricts] = useState([]);
  const [filteredCommunes, setFilteredCommunes] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleAccountCheck = async () => {
    // Reset thông báo lỗi
    setEmtyField({});
    
    // Kiểm tra nếu username hoặc accountNumber trống
    if (!formData.username || !formData.accountNumber) {
      // Nếu có trường trống, hiển thị thông báo lỗi
      toast.warn("Tên tài khoản và STK không được bỏ trống.");
      return; // Dừng không gọi API nếu có trường trống
    }
  
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/gift/check-valid-player`,
        {
          params: {
            customerName: formData.username,
            checkPoint: checkPoint,
            type: type,
            accountNumber: formData.accountNumber
          },
        }
      );
  
      // Kiểm tra kết quả trả về từ API
      if (response.data.statusCode === 200) {
        setIsAccountValid(true);
        setErrorMessage("");
      } else {
        setIsAccountValid(false);
        setErrorMessage(response.data.message);
      }
    } catch (error) {
      console.error("Lỗi khi gọi API:", error);
      setErrorMessage(error?.response?.data?.message);
      toast.error(error?.response?.data?.message || "Đã xảy ra lỗi khi kiểm tra tài khoản.");
    }
  };
  
  
  const handleCreateForm = async () => {
    if (isSubmitting) return; // Nếu đang gửi, không cho phép gửi tiếp
  
    setIsSubmitting(true); // Đánh dấu trạng thái gửi request
  
    const giftNameMap = {
      1: "Combo áo mũ",
      2: "Bộ ấm trà",
      3: "Loa",
    };
    const giftName = giftNameMap[type] || "Không xác định";
  
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/gift/receive`, {
        giftName,
        gender: gender,
        giftSize: size,
        username: formData.username,
        accountNumber: formData.accountNumber,
        fullname: formData.fullName,
        phoneNumber: formData.phoneNumber,
        province: formData.province,
        district: formData.district,
        commune: formData.commune,
        address: formData.address,
        note: formData.note,
        type,
        checkPoint,
      });
  
      if (response.data?.message === 'Đăng ký nhận quà thành công!') {
        toast.success(
          <div style={{ width: "600px" }}>
            Đăng ký quà tặng thành công. <br />
            Sản phẩm sẽ được vận chuyển trong thời gian tối đa 14 ngày (2 tuần).
          </div>
        );
      } else {
        toast.error(response.data?.message || "Gửi quà tặng không thành công.");
      }
    } catch (error) {
      console.error("Lỗi khi gửi quà tặng:", error);
      toast.error(error?.response?.data?.message || "Đã xảy ra lỗi khi gửi quà tặng.");
    } finally {
      setIsSubmitting(false); // Reset trạng thái gửi sau khi hoàn tất
    }
  };
  
  const handleSubmitGift = async () => {
    if (isSubmitting) return; // Chặn nếu đang gửi request
  
    const requiredFields = ['username', 'accountNumber', 'fullName', 'phoneNumber', 'province', 'district', 'commune', 'address'];
    const newErrors = {};
    setErrorMessage('');
  
    requiredFields.forEach((field) => {
      if (!formData[field] || formData[field].trim() === '') {
        newErrors[field] = 'Không được để trống!';
      }
    });
  
    if (!/^0\d{9}$/.test(formData.phoneNumber)) {
      newErrors['phoneNumber'] = 'Số điện thoại phải có 10 số và bắt đầu bằng 0!';
    }
  
    if (Object.keys(newErrors).length > 0) {
      setEmtyField(newErrors);
      console.log(newErrors);
      return;
    }
  
    setEmtyField({});
    handleCreateForm(); 
  }; 

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    
    if (name === 'province') {
        const selectedProvince = vietnamData.province.find((province) => province.name === value);
        if (selectedProvince) {
          const districts = vietnamData.district.filter(
            (district) => district.idProvince === selectedProvince.idProvince
          );
          setFilteredDistricts(districts);
        }
        
        setFilteredCommunes([]);
      }

      if (name === 'district') {
        const selectedDistrict = vietnamData.district.find((district) => district.idDistrict === value);
        
        if (selectedDistrict) {
          const communes = vietnamData.commune.filter(
            (commune) => commune.idDistrict === selectedDistrict.idDistrict
          );
          setFilteredCommunes(communes);
        }
      }
  };

  if (!isOpen) return null;
  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-50 z-20 flex items-center justify-center p-2 sm:p-4">
        <div className="relative bg-white w-full max-w-sm sm:max-w-2xl p-4 sm:p-8 rounded-xl shadow-lg max-h-[70vh] sm:max-h-[90vh] overflow-y-auto">
          <h2 className="text-center text-2xl font-bold text-[#2B8DFE] mb-6">Thông tin nhận quà</h2>
          <div className="mb-4">
            <div className="flex flex-col sm:flex-row items-center w-full gap-4"> 
              <div className="flex-1 w-full">
                <label htmlFor="username" className="block mb-2 text-xs font-medium text-gray-900 dark:text-white">
                  Tên tài khoản
                </label>
                <input
                  type="text"
                  id="username"
                  name="username"
                  value={formData.username}
                  onChange={handleInputChange}
                  className={`w-full p-3 text-gray-900 border border-gray-300 rounded-lg bg-gray-50 text-sm focus:ring-blue-500 focus:border-blue-500 ${emtyField.username ? 'is-invalid' : ''}`}
                  placeholder="Nhập tên tài khoản"
                  disabled={isAccountValid}
                />
                {emtyField.username && <div className="text-red-500 mt-2">{emtyField.username}</div>}
              </div>

              <div className="flex-1 w-full">
                <label htmlFor="accountNumber" className="block text-xs mb-2 font-medium text-gray-900 dark:text-white">
                  STK liên kết ngân hàng (4 số cuối)
                </label>
                <input
                  type="text"
                  id="accountNumber"
                  name="accountNumber"
                  value={formData.accountNumber}
                  onChange={handleInputChange}
                  className={`w-full p-3 text-gray-900 border border-gray-300 rounded-lg bg-gray-50 text-sm focus:ring-blue-500 focus:border-blue-500 ${emtyField.accountNumber ? 'is-invalid' : ''}`}
                  placeholder="Nhập STK"
                  disabled={isAccountValid}
                />
                {emtyField.accountNumber && <div className="text-red-500 mt-2">{emtyField.accountNumber}</div>}
              </div>

              <div className=" w-full sm:w-auto flex justify-end sm:justify-start">
                <button
                  type="button"
                  onClick={handleAccountCheck}
                  className="px-4 py-3 sm:mt-6 right-0 bg-blue-500 text-white rounded-lg hover:bg-blue-600 w-full sm:w-auto"
                >
                  Kiểm tra
                </button>
              </div>
            </div>
          </div>

  
          <div className="mb-4 flex flex-col sm:flex-row gap-4">
            <div className="w-full">
              <label className="block text-xs font-medium text-gray-900 dark:text-white">Họ và tên</label>
              <input
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleInputChange}
                className={`block w-full p-2 border ${isAccountValid ? "bg-white cursor-text" : "bg-gray-200 cursor-not-allowed"} rounded-lg ${emtyField.fullName ? 'is-invalid' : ''}`}
                disabled={!isAccountValid}
                placeholder="Nhập họ và tên"
                required
              />
              {emtyField.fullName && <div className="text-red-500 mt-2">{emtyField.fullName}</div>}
            </div>

            <div className="w-full">
              <label className="block text-xs font-medium text-gray-900 dark:text-white">Số điện thoại</label>
              <input
                type="text"
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleInputChange}
                className={`block w-full p-2 border ${isAccountValid ? "bg-white cursor-text" : "bg-gray-200 cursor-not-allowed"} rounded-lg`}
                disabled={!isAccountValid}
                placeholder="Nhập số điện thoại"
                required
              />
              {emtyField.phoneNumber && <p className="text-red-500 text-sm mt-1">{emtyField.phoneNumber}</p>}
            </div>
          </div>
          <div className="mb-4">
            <div className="w-full">
                <label className="block text-xs font-medium text-gray-900 dark:text-white">Tỉnh/Thành phố</label>
                <select
                name="province"
                value={formData.province}
                onChange={handleInputChange}
                className={`block w-full p-2 border ${isAccountValid ? "bg-white cursor-text" : "bg-gray-200 cursor-not-allowed"} rounded-lg`}
                // disabled={!isAccountValid}
                required
                >
                <option value="">Chọn tỉnh/thành phố</option>
                {vietnamData.province.map((province) => (
                    <option key={province.idProvince} value={province.name}>
                    {province.name}
                    </option>
                ))}
                </select>
                {emtyField.province && <div className="text-red-500 mt-2 ">{emtyField.province}</div>}
            </div>
            </div>

            <div className="mb-4 flex flex-col sm:flex-row gap-4">
              <div className="w-full">
                <label className="block text-xs font-medium text-gray-900 dark:text-white">Quận/Huyện</label>
                <select
                  name="district"
                  value={formData.district}
                  onChange={handleInputChange}
                  className={`block w-full p-2 border ${isAccountValid ? "bg-white cursor-text" : "bg-gray-200 cursor-not-allowed"} rounded-lg`}
                  // disabled={!isAccountValid || !filteredDistricts.length}
                  required
                >
                  <option value="">Chọn quận/huyện</option>
                  {filteredDistricts.map((district) => (
                    <option key={district.idDistrict} value={district.idDistrict}>
                      {district.name}
                    </option>
                  ))}
                </select>
                {emtyField.district && <div className="text-red-500 mt-2">{emtyField.district}</div>}
              </div>

              <div className="w-full">
                <label className="block text-xs font-medium text-gray-900 dark:text-white">Xã/Phường/Thị trấn</label>
                <select
                  name="commune"
                  value={formData.commune}
                  onChange={handleInputChange}
                  className={`block w-full p-2 border ${isAccountValid ? "bg-white cursor-text" : "bg-gray-200 cursor-not-allowed"} rounded-lg`}
                  // disabled={!isAccountValid || !filteredCommunes.length}
                  required
                >
                  <option value="">Chọn xã/phường</option>
                  {filteredCommunes.map((commune) => (
                    <option key={commune.idCommune} value={commune.name}>
                      {commune.name}
                    </option>
                  ))}
                </select>
                {emtyField.commune && <div className="text-red-500 mt-2">{emtyField.commune}</div>}
              </div>
            </div>

          <div className="mb-4">
            <div className="w-full">
              <label className="block text-xs font-medium text-gray-900 dark:text-white">Địa chỉ</label>
              <input
                type="text"
                name="address"
                value={formData.address}
                onChange={handleInputChange}
                className={`block w-full p-2 border ${isAccountValid ? "bg-white cursor-text" : "bg-gray-200 cursor-not-allowed"} rounded-lg`}
                disabled={!isAccountValid}
                placeholder="Nhập địa chỉ"
                required
              />
              {emtyField.address && <div className="text-red-500 mt-2 ">{emtyField.address}</div>}
            </div>
          </div>
  
          <div className="mb-4">
            <label className="block text-xs font-medium text-gray-900 dark:text-white">Ghi chú</label>
            <textarea
              name="note"
              value={formData.note}
              onChange={handleInputChange}
              className={`block w-full p-2 border ${isAccountValid ? "bg-white cursor-text" : "bg-gray-200 cursor-not-allowed"} rounded-lg`}
              disabled={!isAccountValid}
              placeholder="Nhập ghi chú (nếu có)"
            />
          </div>
  
          <div className="flex justify-end mt-6">
          <button
            onClick={handleSubmitGift}
            disabled={isSubmitting}
            className={`px-6 py-2 rounded-lg text-white 
              ${isSubmitting ? "bg-gray-400 cursor-not-allowed" : "bg-blue-500 hover:bg-blue-600"}
            `}
          >
            {isSubmitting ? "Đang gửi..." : "Gửi"}
          </button>
            <button
              onClick={closeModal}
              className="ml-4 bg-gray-300 text-black px-6 py-2 rounded-lg hover:bg-gray-400"
            >
              Hủy
            </button>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );  
};

export default OrderFormModal;
